import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  public controlList = [];
  _state = true;
  set state(val) {
    this._state = val;
  };

  get state() {
    return this._state;
  }

  constructor(private router: Router) {

    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.controlList.splice(0);
      });
  }

  showErrorBannerSource$:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
  showErrorBanner$=this.showErrorBannerSource$.asObservable();
  errorPhone$:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);

  getInvalidControls() {
    return this.controlList.find(control => control.invalid) || null;
  }

  registerControl(control, destroy?) {
    if (destroy && control) {
      const index = this.controlList.findIndex(ctrl => ctrl === control);
      if (index !== -1) {
        this.controlList.splice(index, 1);
      }
    }
    setTimeout(() => {
      if (!destroy && document.body.contains(control?.nativeElement) && !this.controlList.some(ctrl => ctrl === control)) {
        this.controlList.push(control);
      }
      if (this.router.url === '/home/object-details') {
        this.state = true;
      }
      setTimeout(() => {
        this.state = !!this.controlList.find(control => control.invalid);
      }, 200)

    });
  }
}
